import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "../../styles/admin-layout.css";

const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : process.env.REACT_APP_API_BASE_URL ||
      "https://apti-backend-8fhm.onrender.com";

const ADMIN_API_KEY = process.env.REACT_APP_ADMIN_API_KEY;

export default function AdminLayout({
  children,
  title,
  subtitle
}) {
  const [universityName, setUniversityName] = useState("University");

  useEffect(() => {
    if (!ADMIN_API_KEY) return undefined;

    const controller = new AbortController();

    const loadUniversityProfile = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/university/profile`, {
          headers: {
            "x-api-key": ADMIN_API_KEY
          },
          signal: controller.signal
        });
        const result = await response.json();
        const resolvedName = result?.data?.name;

        if (response.ok && typeof resolvedName === "string" && resolvedName.trim()) {
          setUniversityName(resolvedName.trim());
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          setUniversityName("University");
        }
      }
    };

    loadUniversityProfile();

    return () => controller.abort();
  }, []);

  return (
    <div className="admin-layout">

      <Sidebar />

      <div className="admin-main">

        <Topbar
          title={title}
          subtitle={subtitle}
          universityName={universityName}
        />

        <main className="admin-content">
          {children}
        </main>

      </div>

    </div>
  );
}
